import type { IHttpRequest, IHttpResponse } from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { type SaveVisitOptions, VisitDto } from './save-visit.types';

export function saveVisit(
  baseUrl: string,
  payload: VisitDto,
  options?: SaveVisitOptions,
): Promise<IHttpResponse<void>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<VisitDto> = {
    url: `${baseUrl}/api/v2/journeys/visits`,

    method: 'POST',
    body: payload,
    headers,
    schemas: {
      request: VisitDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
